import type { PaginatedResponse } from "@models/common";
import type {
  ProviderResponse, ProviderViewModel,
  CredentialResponse, CredentialViewModel,
  PolicyResponse, PolicyViewModel,
} from "@models/provider";

export const buildProviderViewModel = (response: ProviderResponse): ProviderViewModel => ({
  id: response.id,
  key: response.key,
  type: response.type,
  status: response.status,
  createdAt: new Date(response.created_at),
});

export const buildPaginatedProvidersViewModel = (
  response: PaginatedResponse<ProviderResponse>,
): PaginatedResponse<ProviderViewModel> => ({
  ...response,
  items: response.items.map(buildProviderViewModel),
});

export const buildCredentialViewModel = (r: CredentialResponse): CredentialViewModel => ({
  id: r.id,
  providerId: r.provider_id,
  name: r.name,
  scopeKey: r.scope_key,
  endpoint: r.endpoint,
  apiVersion: r.api_version,
  createdAt: new Date(r.created_at),
});

export const buildPolicyViewModel = (r: PolicyResponse): PolicyViewModel => ({
  id: r.id,
  scopeKey: r.scope_key,
  capability: r.capability,
  defaultProviderId: r.default_provider_id,
  defaultModel: r.default_model,
  allowedModels: r.allowed_models,
  createdAt: new Date(r.created_at),
});
